import React from 'react';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import ExpertFormation from '../components/ExpertFormation';
import AutresFormations from '../components/AutresFormations';
import Temoignages from '../components/Temoignages';
import Tarifs from '../components/Tarifs';
import Contact from '../components/Contact';
import Inscription from '../components/Inscription';
import Footer from '../components/Footer';

const Index = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <HeroSection />
      <ExpertFormation />
      <AutresFormations />
      <Temoignages />
      <Tarifs />
      <Contact />
      <Inscription />
      <Footer />
    </div>
  );
};

export default Index;
